import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { cnTooltip } from '../Tooltip.cn';

import './Tooltip-Backdrop.css';

export const TooltipBackdrop: FC<PropsWithChildren<{}>> = ({ children }) => (
    <div className={cnTooltip('Backdrop')}>{children}</div>
);
